import { decodeHTML } from 'entities';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import $ from 'jquery';
import 'summernote/dist/summernote-lite.min.css';
import 'summernote/dist/summernote-lite.min.js';
import 'summernote/dist/lang/summernote-ko-KR';


import { resetData, updateData } from '../../../../redux/reducers/PAJAC020';
import {
    getCommonInfo,
    getPAJAC020,
    getPAJAC020CodeList,
    getPAJAC020TaskManager,
    postPAJAC020Step1,
    putPAJAC020Step1,
    uploadRecruitImage
} from '../../../../services/Api';
import Checkbox from '../../../../shared/components/Checkbox';
import Dropdown from '../../../../shared/components/Dropdown';
import ImageCheckFallback from '../../../../shared/components/ImageCheckFallback';
import PinAddress from '../../../../shared/components/PinAddress';
import PreviewPinAddress from '../../../../shared/components/PreviewPinAddress';
import Radiobox from '../../../../shared/components/Radiobox';
import { PHONE_OPTIONS } from '../../../../shared/constants/app';
import { decodeHTMLEntities, handleFocus } from '../../../../utils';

window.$ = $;
window.jQuery = $;

// Các mã 군/구 cũ đã bị bỏ: không cho chọn mới và bắt chọn lại theo hành chính mới khi lưu.
const excludedGuCodes = ['305', '307', '310'];

const PAJAC020 = ({ updateUserData }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const { id } = useParams();
    const isUpdate = searchParams.get('update') === 'true';
    const isFlag = searchParams.get('flag') === 'true';
    const [info, setInfo] = useState({});
    const editorRef = useRef(null);
    const imageFilesRef = useRef([]);

    const [filteredA17_1, setFilteredA17_1] = useState([]);
    const [filteredA17_2, setFilteredA17_2] = useState([]);
    const [filteredA17_3, setFilteredA17_3] = useState([]);

    const [filteredRegionGu, setFilteredRegionGu] = useState([]);
    const [regionSi, setRegionSi] = useState([]);
    const [regionGu, setRegionGu] = useState([]);

    const [checkSubwayPosts, setCheckSubwayPosts] = useState({
        subwayPost1: false,
        subwayPost2: false,
        subwayPost3: false,
    });

    const [showPopupMap, setShowPopupMap] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [position, setPosition] = useState({ lat: null, lng: null });

    const normalizeSummernoteContent = (html) => {
        if (!html || typeof html !== 'string') return '';

        // Decode HTML entities
        const textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        let decoded = textarea.value;

        // &nbsp; → space
        decoded = decoded.replace(/\u00A0/g, ' ');

        // comma → ,
        decoded = decoded.replace(/comma/g, ',');

        // newline → <br>
        decoded = decoded.replace(/\r?\n/g, '<br>');

        return decoded;
    };


    useEffect(() => {
        $(editorRef.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview']],
            ],
            callbacks: {
                onImageUpload: function (files) {
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i];
                        const tempId = `temp-${Date.now()}-${i}`;


                        imageFilesRef.current.push({ tempId, file });

                        const reader = new FileReader();
                        reader.onload = function (e) {
                            $(editorRef.current).summernote(
                                "insertImage",
                                e.target.result,
                                function ($image) {
                                    $image.attr("data-temp-id", tempId);
                                }
                            );
                        };
                        reader.readAsDataURL(file);
                    }
                }
            }
        });
    }, []);

    async function uploadAndReplaceAllImages(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newImages = imageFilesRef.current;

        for (const item of newImages) {
            const res = await uploadRecruitImage(item.file);

            const imageUrl =
                `https://api.dentaljob.co.kr/api/v1/files/recruit/${res.data.fileName}`;

            const img = doc.querySelector(
                `img[data-temp-id="${item.tempId}"]`
            );

            if (img) {
                img.setAttribute("src", imageUrl);
                img.removeAttribute("data-temp-id");
            }
        }


        const base64Imgs = doc.querySelectorAll('img[src^="data:image"]');
        for (const img of base64Imgs) {
            const base64 = img.getAttribute("src");
            const file = base64ToFile(base64, "base64.png");
            const res = await uploadRecruitImage(file);
            const imageUrl =
                `https://api.dentaljob.co.kr/api/v1/files/recruit/${res.data.fileName}`;

            img.setAttribute("src", imageUrl);
        }

        imageFilesRef.current = [];

        return doc.body.innerHTML;
    }

    function base64ToFile(base64, filename) {
        const arr = base64.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }




    const [chargePhoneParts, setChargePhoneParts] = useState({
        chargeTel1: '02',
        chargeTel2: '',
        chargeTel3: '',
        chargeMobile1: '010',
        chargeMobile2: '',
        chargeMobile3: '',
    });

    const [payload, setPayload] = useState({
        recruitFrom: moment().format('YYYY-MM-DD HH:mm:ss'),
        recruitEnd: moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        changeInfo: 'N',
        recruitClass: '',
        recruitLicense: '',
        recruitForm: '',
        recruitNum: '',
        recruitPosition: '',
        recruitPay: '',
        recruitPayEtc: '',
        recruitGrade: '',
        recruitGradeEtc: '',
        recruitCareer: '',
        recruitCareerYear: '',
        recruitDetails: '',
        recruitClassInfo: '',
        recruitDay: '',
        recruitDayEtc: '',
        recruitTime: '',
        assist1: '',
        assist2: '',
        assist3: '',
        assist4: '',
        assist5: '',
        conditionEtc: '',
        applyMethod1: '001',
        applyMethod2: '',
        applyMethod3: '',
        applyMethod4: '',
        applyMethod5: '',
        needPaper: '',
        needPaperEtc: '',
        recruitFlow: '',
        proposeSMS: '',
        title: '',
        contents: '',
        applyMethod002: '',
        phoneNumber: '',
        applyMethod003: '',
        email: '',
        applyMethod004: '',
        fax: '',
        applyMethod005: '',
        address: '',
        recruitCareerYearFrom: '',
        recruitCareerYearTo: '',
        recruitFlowCheck1: '',
        recruitFlowCheck2: '',
        recruitFlowCheck3: '',
        recruitFlowText1: '',
        recruitFlowText2: '',
        recruitFlowText3: '',
        recruitFlowTextOpen1: '',
        recruitFlowTextOpen2: '',
        recruitFlowTextOpen3: '',
        subwayPost1: '',
        subwayPost2: '',
        subwayPost3: '',
        subwayNum1: '',
        subwayNum2: '',
        subwayNum3: '',
        bizAddrDesc: '',
        mapSvr: 'Y',
        pointX: '',
        pointY: '',
        mapStr: '',
        regionSi: '',
        regionGu: '',
        regionDetail: '',
    });

    const [mapSvr, setMapSvr] = useState(payload.mapSvr || 'Y');

    const [A10, setA10] = useState([]);
    const [A11, setA11] = useState([]);
    const [A12, setA12] = useState([]);
    const [A14, setA14] = useState([]);
    const [A16, setA16] = useState([]);
    const [A17, setA17] = useState([]);
    const [A19, setA19] = useState([]);
    const [A26, setA26] = useState([]);
    const [A27, setA27] = useState([]);
    const [A31, setA31] = useState([]);
    const [A46, setA46] = useState([]);

    // recruitClass / recruitLicense / recruitForm được lưu dạng "001_002_003".
    // Dữ liệu cũ có thể trả về dạng "001,002" -> nếu chỉ split('_') thì cả cụm
    // "001,002" bị coi là 1 phần tử, sinh ra chuỗi lỗi "001_001,002_002".
    const splitCodes = (raw) =>
        String(raw ?? '')
            .split(/[_,]/)
            .map((s) => s.trim())
            .filter(Boolean);

    const joinCodes = (codes) => [...new Set(codes)].sort().join('_');

    // các field còn lại (assist*, needPaper, applyMethod*, recruitPosition) lưu dạng
    // "a,b,c" - dữ liệu cũ có thể có khoảng trắng thừa nên phải trim khi đọc.
    const splitList = (raw) =>
        String(raw ?? '')
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);

    const parsePhoneNumbers = (chargeTel, chargeMobile) => {
        const chargeTelPartsArray = String(chargeTel ?? '').split('-');
        const chargeMobilePartsArray = String(chargeMobile ?? '').split('-');

        setChargePhoneParts({
            chargeTel1: chargeTelPartsArray[0] ? chargeTelPartsArray[0] : '02',
            chargeTel2: chargeTelPartsArray[1],
            chargeTel3: chargeTelPartsArray[2],
            chargeMobile1: chargeMobilePartsArray[0] ? chargeMobilePartsArray[0] : '010',
            chargeMobile2: chargeMobilePartsArray[1],
            chargeMobile3: chargeMobilePartsArray[2],
        });
    };

    useEffect(() => {
        getCommonInfo()
            .then(({ data }) => {
                setInfo(data);
            })
            .catch((error) => console.log(error));
        getPAJAC020TaskManager()
            .then(({ data }) => {
                setA11(data);
            })
            .catch((error) => console.log(error));
        getPAJAC020CodeList('A10,A11,A14,A12,A27,A26,A19,A31,A46,A16,A17,A06,A15')
            .then(({ data }) => {
                setA10(data.A10);
                setA12(data.A12);
                setA14(data.A14);
                setA16(data.A16);
                setA17(data.A17);
                setA19(data.A19);
                setA26(data.A26);
                setA27(data.A27);
                setA31(data.A31);
                setA46(data.A46);
                setRegionSi(data.A06);
                setRegionGu(data.A15);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        if (id) {
            getPAJAC020(id)
                .then(({ data }) => {
                    const keysToKeep = [
                        'memberID',
                        'recruitFrom',
                        'recruitEnd',
                        'changeInfo',
                        'recruitClass',
                        'recruitLicense',
                        'recruitForm',
                        'recruitNum',
                        'recruitPosition',
                        'recruitPay',
                        'recruitPayEtc',
                        'recruitGrade',
                        'recruitGradeEtc',
                        'recruitCareer',
                        'recruitCareerYear',
                        'recruitDetails',
                        'recruitClassInfo',
                        'recruitDay',
                        'recruitDayEtc',
                        'recruitTime',
                        'assist1',
                        'assist2',
                        'assist3',
                        'assist4',
                        'assist5',
                        'conditionEtc',
                        'applyMethod1',
                        'applyMethod2',
                        'applyMethod3',
                        'applyMethod4',
                        'applyMethod5',
                        'needPaper',
                        'needPaperEtc',
                        'recruitFlow',
                        'proposeSMS',
                        'title',
                        'contents',
                        'subwayPost1',
                        'subwayPost2',
                        'subwayPost3',
                        'subwayNum1',
                        'subwayNum2',
                        'subwayNum3',
                        'bizAddrDesc',
                        'mapSvr',
                        'pointX',
                        'pointY',
                        'mapStr',
                        'regionSi',
                        'regionGu',
                        'regionDetail',
                        'charge',
                        'chargeEmail',
                        'chargeTel',
                        'chargeMobile',
                    ];

                    const filteredData = Object.keys(data)
                        .filter((key) => keysToKeep.includes(key))
                        .reduce((obj, key) => {
                            obj[key] = data[key];
                            return obj;
                        }, {});

                    // chuẩn hoá dữ liệu cũ ("001,002") về đúng định dạng "001_002"
                    ['recruitClass', 'recruitLicense', 'recruitForm'].forEach((key) => {
                        if (key in filteredData) {
                            filteredData[key] = joinCodes(splitCodes(filteredData[key]));
                        }
                    });

                    // const recruitFlowSpace = data.recruitFlow?.split(' ');
                    // const recruitFlowText1 = recruitFlowSpace[0]?.split('&amp;nbsp;') || '';
                    // const recruitFlowText2 = recruitFlowSpace[1]?.split('&amp;nbsp;') || '';
                    // const recruitFlowText3 = recruitFlowSpace[2]?.split('&amp;nbsp;') || '';

                    const parseRecruitFlow = (raw) => {
                        if (!raw) return [[], [], []];

                        const cleaned = raw.replace(/&amp;nbsp;\s*:\s*&amp;nbsp;/g, '&amp;nbsp;');

                        const oneLine = cleaned
                            .split(/\n+/)
                            .map((line) => line.trim())
                            .filter((line) => /^\d차&amp;nbsp;/.test(line))
                            .join(' ');

                        const normalized = oneLine.length > 0 ? oneLine : cleaned.trim();


                        const parts = normalized.split(/ (?=\d차&amp;nbsp;)/);

                        const splitPart = (part) => {
                            if (!part) return [];
                            const arr = part.split('&amp;nbsp;').map((s) => s.trim());
                            if (!arr[0] || !/^\d차$/.test(arr[0])) return [];
                            return arr;
                        };

                        return [
                            splitPart(parts[0]),
                            splitPart(parts[1]),
                            splitPart(parts[2]),
                        ];
                    };

                    const [recruitFlowText1, recruitFlowText2, recruitFlowText3] =
                        parseRecruitFlow(data.recruitFlow);

                    const recruitFlowText1Final =
                        recruitFlowText1[0] &&
                            (recruitFlowText1[1] === '서류전형' ||
                                recruitFlowText1[1] === '면접' ||
                                recruitFlowText1[1] === '최종면접')
                            ? recruitFlowText1[1]
                            : recruitFlowText1[1]
                                ? '직접 입력'
                                : '';

                    const recruitFlowText2Final =
                        recruitFlowText2[0] &&
                            (recruitFlowText2[1] === '서류전형' ||
                                recruitFlowText2[1] === '면접' ||
                                recruitFlowText2[1] === '최종면접')
                            ? recruitFlowText2[1]
                            : recruitFlowText2[1]
                                ? '직접 입력'
                                : '';

                    const recruitFlowText3Final =
                        recruitFlowText3[0] &&
                            (recruitFlowText3[1] === '서류전형' ||
                                recruitFlowText3[1] === '면접' ||
                                recruitFlowText3[1] === '최종면접')
                            ? recruitFlowText3[1]
                            : recruitFlowText3[1]
                                ? '직접 입력'
                                : '';

                    if (editorRef.current && data?.contents) {
                        $(editorRef.current).summernote(
                            'code',
                            normalizeSummernoteContent(data.contents)
                        );
                    }

                    parsePhoneNumbers(data.chargeTel, data.chargeMobile);

                    setPayload((prevState) => ({
                        ...prevState,
                        ...filteredData,
                        applyMethod002: data.applyMethod2?.split('|')[0] || '',
                        phoneNumber: data.applyMethod2?.split('|')[1] || '',
                        applyMethod003: data.applyMethod3?.split('|')[0] || '',
                        email: data.applyMethod3?.split('|')[1] || '',
                        applyMethod004: data.applyMethod4?.split('|')[0] || '',
                        fax: data.applyMethod4?.split('|')[1] || '',
                        applyMethod005: data.applyMethod5?.split('|')[0] || '',
                        address: data.applyMethod5?.split('|')[1] || '',
                        recruitCareerYearFrom: data.recruitCareerYear?.split('_')[0] || '',
                        recruitCareerYearTo: data.recruitCareerYear?.split('_')[1] || '',
                        recruitFlowCheck1: recruitFlowText1[0] || '',
                        recruitFlowText1: recruitFlowText1Final,
                        recruitFlowTextOpen1: recruitFlowText1Final === '직접 입력' ? recruitFlowText1[1] : '',
                        recruitFlowCheck2: recruitFlowText2[0] || '',
                        recruitFlowText2: recruitFlowText2Final,
                        recruitFlowTextOpen2: recruitFlowText2Final === '직접 입력' ? recruitFlowText2[1] : '',
                        recruitFlowCheck3: recruitFlowText3[0] || '',
                        recruitFlowText3: recruitFlowText3Final,
                        recruitFlowTextOpen3: recruitFlowText3Final === '직접 입력' ? recruitFlowText3[1] : '',
                        recruitTime: decodeHTML(decodeHTMLEntities(data.recruitTime)),
                    }));
                })
                .catch((error) => console.log(error));
        }
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        if (payload && A17) {
            filterSubway('subwayNum1', payload.subwayNum1);
            filterSubway('subwayNum2', payload.subwayNum2);
            filterSubway('subwayNum3', payload.subwayNum3);
        }
        if (payload && regionGu) {
            filterRegionGu(payload.regionSi);
        }
        // eslint-disable-next-line
    }, [A17, payload]);

    const getOptions = (name, filterCode) => {
        const options = {
            A10: A10.map((item) => ({
                id: 'a10_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            A11: A11.map((item) => ({
                id: 'a11_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            A12: A12.map((item) => ({
                id: 'a12_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            A14: A14.map((item) => ({
                id: 'a14_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            A16: A16.map((item) => ({
                id: 'a16_' + item.code,
                option: item.codeName,
                value: item.code,
            })),
            A17: A17.map((item) => ({
                id: 'a17_' + item.code,
                option: item.codeName,
                value: item.code,
            })),
            A19: A19.map((item) => ({
                id: 'a19_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            A27: A27.map((item) => ({
                id: 'a27_' + item.code,
                label: item.codeName,
                option: item.codeName,
                value: item.codeName,
            })),
            A26: A26.map((item) => ({
                id: 'a26_' + item.code,
                option: item.codeName,
                value: item.codeName,
            })),
            A31: A31.map((item) => ({
                id: 'a31_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            A46: A46.map((item) => ({
                id: 'a46_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            RegionSi: regionSi.map((item) => ({
                id: 'RegionSi_' + item.code,
                option: item.codeName,
                value: item.code,
            })),
        };

        if (name === 'A19') {
            if (filterCode === '999') {
                return options[name].filter((item) => item.value === '999');
            } else {
                return options[name].filter((item) => item.value !== '999');
            }
        }

        if (filterCode && filterCode.length > 0 && name !== 'RegionGu') {
            return options[name].filter((item) => filterCode.includes(item.value));
        }

        if (name === 'RegionGu') {
            // Không cho chọn các mã 군/구: 305, 307, 310.
            // Nếu bản ghi đã lưu sẵn một trong các mã đó thì vẫn giữ lại option (ẩn khỏi list)
            // để selectbox hiển thị đúng text đã lưu.
            options['RegionGu'] = filteredRegionGu
                .filter(
                    (item) =>
                        !excludedGuCodes.includes(String(item.code)) ||
                        String(payload.regionGu) === String(item.code),
                )
                .map((item) => ({
                    id: 'regionGu_' + item.code,
                    option: item.codeName,
                    value: item.code,
                    hidden: excludedGuCodes.includes(String(item.code)),
                }));
            return options['RegionGu'];
        } else if (name === 'A17') {
            const targetArray =
                filterCode === 1
                    ? filteredA17_1
                    : filterCode === 2
                        ? filteredA17_2
                        : filterCode === 3
                            ? filteredA17_3
                            : [];
            options[`A17_${filterCode}`] = targetArray.map((item) => ({
                id: `a17_${filterCode}_${item.code}`,
                option: item.codeName,
                value: item.code,
            }));
            return options[`A17_${filterCode}`];
        } else {
            return options[name];
        }
    };

    const handleOpenPopupMap = (mode) => {
        setShowPopupMap(true);
        setIsEditMode(mode === 'edit');
        setPosition({ lat: payload.pointY, lng: payload.pointX });
    };

    const handleOptionChange = (selectedValue, name) => {
        setPayload((prevState) => {
            const updatedPayload = {
                ...prevState,
                [name]: selectedValue,
            };

            if (name === 'recruitCareer' && selectedValue !== '경력') {
                updatedPayload.recruitCareerYearFrom = '';
                updatedPayload.recruitCareerYearTo = '';
            }
            return updatedPayload;
        });
    };

    const handlePhonePartChange = (part, value) => {
        setChargePhoneParts((prev) => ({
            ...prev,
            [part]: value,
        }));
    };

    const handleCheckboxChange = (e) => {
        const { name, value: rawValue, type, checked } = e.target;
        const value = String(rawValue); // đảm bảo là string

        // console.log("Name: " + name + " Value: " + value + " Checked: " + checked);

        setPayload((prevState) => {
            const updatedState = { ...prevState };

            if (type === 'radio') {
                updatedState[name] = value;
                return updatedState;
            }

            if (type === 'checkbox') {
                // ensure key exists as string
                if (!updatedState[name]) updatedState[name] = '';

                // Special handling for recruitClass / recruitLicense / recruitForm (underscore-separated)
                if (name === 'recruitClass' || name === 'recruitLicense' || name === 'recruitForm') {
                    const parts = splitCodes(updatedState[name]);

                    if (checked) {
                        if (!parts.includes(value)) parts.push(value);
                    } else {
                        // unchecked -> remove
                        const idx = parts.indexOf(value);
                        if (idx > -1) parts.splice(idx, 1);
                    }

                    updatedState[name] = joinCodes(parts);

                    return updatedState;
                }

                // General checkbox logic (comma-separated lists)
                // Special-case for needPaper with value '999' (clear others when 999 is checked)
                if (name === 'needPaper') {
                    const current = splitList(updatedState[name]);

                    if (value === '999') {
                        if (checked) {
                            // When 999 is checked -> keep only 999
                            updatedState[name] = '999';
                        } else {
                            // When 999 is unchecked -> remove it
                            updatedState[name] = current.filter((v) => v !== '999').join(',');
                        }
                    } else {
                        // value !== '999'
                        if (checked) {
                            // add value and ensure 999 removed if exists
                            const without999 = current.filter((v) => v !== '999');
                            if (!without999.includes(value)) without999.push(value);
                            updatedState[name] = without999.join(',');
                        } else {
                            // unchecked -> remove the value
                            const next = current.filter((v) => v !== value);
                            updatedState[name] = next.join(',');
                        }
                    }

                    return updatedState;
                }

                // recruitPosition: giá trị là codeName nên phải so khớp từng phần tử,
                // không dùng includes() trên cả chuỗi (vd '원장' nằm trong '부원장')
                if (name === 'recruitPosition') {
                    const parts = splitList(updatedState[name]);

                    if (checked) {
                        if (!parts.includes(value)) parts.push(value);
                    } else {
                        const idx = parts.indexOf(value);
                        if (idx > -1) parts.splice(idx, 1);
                    }

                    updatedState[name] = parts.join(', ');
                    return updatedState;
                }

                // Fallback for other checkboxes (comma-separated).
                // So khớp theo từng phần tử, không dùng includes() trên cả chuỗi.
                const parts = splitList(updatedState[name]);

                if (checked) {
                    if (!parts.includes(value)) parts.push(value);
                } else {
                    const idx = parts.indexOf(value);
                    if (idx > -1) parts.splice(idx, 1);
                }

                updatedState[name] = parts.join(',');
            }

            return updatedState;
        });
    };


    const handleCheckbox = (e) => {
        const { name, value, checked } = e.target;

        setPayload((prev) => {
            const updated = { ...prev };

            updated[name] = checked ? value : '';

            switch (name) {
                case 'recruitFlowCheck1':
                    if (!checked) {
                        updated.recruitFlowCheck2 = '';
                        updated.recruitFlowText2 = '';
                        updated.recruitFlowTextOpen2 = '';
                        updated.recruitFlowCheck3 = '';
                        updated.recruitFlowText3 = '';
                        updated.recruitFlowTextOpen3 = '';
                        updated.recruitFlowText1 = '';
                        updated.recruitFlowTextOpen1 = '';
                    }
                    break;

                case 'recruitFlowCheck2':
                    if (!checked) {
                        updated.recruitFlowCheck3 = '';
                        updated.recruitFlowText3 = '';
                        updated.recruitFlowTextOpen3 = '';
                        updated.recruitFlowText2 = '';
                        updated.recruitFlowTextOpen2 = '';
                    }
                    break;

                case 'recruitFlowCheck3':
                    if (!checked) {
                        updated.recruitFlowTextOpen3 = '';
                    }
                    break;

                default:
                    break;
            }

            return updated;
        });
    };

    const filterRegionGu = (value) => {
        setFilteredRegionGu(regionGu.filter((item) => item.desct === value));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name.startsWith('subwayPost') && value !== '') {
            const dropdownNumber = name.replace('subwayPost', '');
            const isDuplicate = [1, 2, 3].some((num) => {
                if (num === parseInt(dropdownNumber)) return false; // Bỏ qua chính dropdown hiện tại
                const otherSubwayPost = payload[`subwayPost${num}`];
                return otherSubwayPost === value;
            });
            // Nếu có trùng lặp, hiển thị thông báo và không cập nhật
            if (isDuplicate) {
                const subwayPostMap = {
                    subwayPost1: filteredA17_1,
                    subwayPost2: filteredA17_2,
                    subwayPost3: filteredA17_3,
                };
                const labelSubwayPost = subwayPostMap[name]?.filter((item) => item.code === value);
                alert(`${labelSubwayPost[0]?.codeName}역을 이미 선택하셨습니다.`);
                setCheckSubwayPosts((prev) => ({
                    ...prev,
                    [`subwayPost${dropdownNumber}`]: true,
                }));
                return;
            }
        }
        if (name === 'regionSi') {
            filterRegionGu(value);
        }
        if (name.startsWith('subwayNum')) {
            const dropdownNumber = name.replace('subwayNum', '');
            filterSubway(name, value);
            setCheckSubwayPosts((prev) => ({
                ...prev,
                [`subwayPost${dropdownNumber}`]: true,
            }));
            // 호선선택(빈 값) 선택 시 역명도 초기화
            if (value === '') {
                setPayload((prev) => ({
                    ...prev,
                    [name]: '',
                    [`subwayPost${dropdownNumber}`]: '',
                }));
                return;
            }
        }

        // 경력년수: chỉ cho nhập số
        if (name === 'recruitCareerYearFrom' || name === 'recruitCareerYearTo') {
            setPayload((prev) => ({
                ...prev,
                [name]: value.replace(/[^0-9]/g, ''),
            }));
            return;
        }

        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const filterSubway = (name, value) => {
        const subwayNumMap = {
            subwayNum1: setFilteredA17_1,
            subwayNum2: setFilteredA17_2,
            subwayNum3: setFilteredA17_3,
        };

        if (subwayNumMap[name]) {
            subwayNumMap[name](A17.filter((item) => item.desct === value));
        }
    };

    const mergeApplyMethods = (payload) => {
        return {
            ...payload,
            applyMethod2: `${payload.applyMethod002}|${payload.phoneNumber}`,
            applyMethod3: `${payload.applyMethod003}|${payload.email}`,
            applyMethod4: `${payload.applyMethod004}|${payload.fax}`,
            applyMethod5: `${payload.applyMethod005}|${payload.address}`,
        };
    };

    const mergeRecruitCareerYear = (payload) => {
        return {
            ...payload,
            recruitCareerYear: `${payload.recruitCareerYearFrom}_${payload.recruitCareerYearTo}`,
        };
    };

    const mergeRecruitFlow = (payload) => {
        const flow1 =
            payload.recruitFlowText1 === '직접 입력'
                ? `${payload.recruitFlowTextOpen1}`
                : `${payload.recruitFlowText1}`;
        const flow2 =
            payload.recruitFlowText2 === '직접 입력'
                ? `${payload.recruitFlowTextOpen2}`
                : `${payload.recruitFlowText2}`;
        const flow3 =
            payload.recruitFlowText3 === '직접 입력'
                ? `${payload.recruitFlowTextOpen3}`
                : `${payload.recruitFlowText3}`;

        return `${payload.recruitFlowCheck1}&amp;nbsp;${flow1} ${payload.recruitFlowCheck2}&amp;nbsp;${flow2} ${payload.recruitFlowCheck3}&amp;nbsp;${flow3}`;
    };

    const requiredFields = [
        'title',
        'regionSi',
        'regionGu',
        'recruitClass',
        'recruitLicense',
        'recruitForm',
        'recruitNum',
        'recruitPosition',
        'recruitPay',
        'recruitGrade',
        'recruitCareer',
        'recruitDay',
    ];

    const lengthValidations = {
        title: 100,
        recruitDayEtc: 160,
        phoneNumber: 20,
        email: 100,
        fax: 100,
        address: 100,
    };
    const labelInputRequired = {
        title: '제목',
        nameKor: '근무요일 (직접입력)',
        phoneNumber: '접수방법 (전화접수)',
        email: '접수방법 (이메일)',
        fax: '접수방법 (FAX접수)',
        address: '접수방법 (우편접수)',
    };

    function getTextError(field) {
        switch (field) {
            case 'title':
                return '채용공고 제목을 입력해 주세요.';
            case 'regionSi':
                return '근무위치를 선택해 주세요.';
            case 'regionGu':
                return '근무위치를 선택해 주세요.';
            case 'recruitClass':
                return '담당업무를 선택해 주세요.';
            case 'recruitLicense':
                return '필수 자격증을 선택해 주세요.';
            case 'recruitForm':
                return '근무형태를 선택해 주세요.';
            case 'recruitNum':
                return '모집인원을 입력해 주세요.';
            case 'recruitPosition':
                return '직급을 선택해 주세요.';
            case 'recruitPay':
                return '급여를 선택해 주세요.';
            case 'recruitGrade':
                return '자격요건을 선택해 주세요.';
            case 'recruitCareer':
                return '자격요건을 선택해 주세요.';
            case 'recruitCareerYearFrom':
                return '경력 요건이 경력인 경우 경력 연수를 입력해 주세요.';
            case 'recruitCareerYearTo':
                return '경력 요건이 경력인 경우 경력 연수를 입력해 주세요.';
            case 'recruitCareerYear':
                return '최소 경력 연수는 최대 경력 연수보다 작아야 합니다.';
            case 'recruitDay':
                return '근무요일을 선택해 주세요.';
            case 'recruitDayEtc':
                return '근무요일을 입력해 주세요.';
            default:
                return '(*) 표시는 필수 입력 항목입니다';
        }
    }

    // handleFocus không focus được Dropdown (không phải input/select),
    // nên focus trực tiếp vào container có tabIndex của selectbox 군/구.
    const focusRegionGu = () => {
        const element = document.getElementById('regionGu');
        if (!element) return;
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        const focusTarget = element.closest('.form-select-container') || element;
        focusTarget?.focus?.();
    };

    const validateForm = (data) => {
        let errors = {};

        if (data.title) {
            const allowedPattern = /^[\p{L}\p{N}\s\[\]\(\)\/\-&,\.]+$/u;
            if (!allowedPattern.test(data.title)) {
                errors.title = '[ ] ( ) / - & , . 특수문자만 사용할 수 있습니다.';
                handleFocus('title');
                return errors;
            }
        }

        // Người dùng vẫn để 군/구 cũ (305/307/310) mà không chọn lại → bắt chọn lại.
        if (data.regionGu && excludedGuCodes.includes(String(data.regionGu))) {
            errors.regionGu = '새로운 행정구역으로 근무지를 설정해주세요.';
            focusRegionGu();
            return errors;
        }

        if (data.recruitCareer === '경력') {
            if (!data.recruitCareerYearTo) {
                requiredFields.unshift('recruitCareerYearTo');
            }
            if (!data.recruitCareerYearFrom) {
                requiredFields.unshift('recruitCareerYearFrom');
            }
            if (data.recruitCareerYearFrom && data.recruitCareerYearTo) {
                if (Number(data.recruitCareerYearFrom) > Number(data.recruitCareerYearTo)) {
                    requiredFields.unshift('recruitCareerYear');
                    handleFocus('recruitCareerYearFrom');
                }
            }
        }
        if (data.recruitPay === '직접입력') {
            requiredFields.unshift('recruitPayEtc');
        }
        if (data.recruitDay === '999') {
            requiredFields.unshift('recruitDayEtc');
        }
        // const applyMethodMap = {
        //     '002': 'phoneNumber',
        //     '003': 'email',
        //     '004': 'fax',
        //     '005': 'address',
        // };
        // Object.entries(applyMethodMap).forEach(([method, field]) => {
        //     if (data[`applyMethod${method}`] === method) {
        //         requiredFields.unshift(field);
        //     }
        // });

        let missingFields = requiredFields.filter((field) => {
            return !data[field] || data[field].trim() === '';
        });

        if (missingFields?.length > 0) {
            const firstMissingFields = missingFields[0];
            errors[firstMissingFields] = getTextError(firstMissingFields);
            handleFocus(firstMissingFields);
        } else {
            for (const field in lengthValidations) {
                if (data[field] && data[field].length > lengthValidations[field]) {
                    errors[
                        field
                    ] = `${labelInputRequired[field]} 최대 ${lengthValidations[field]} 글자까지만 입력이 가능합니다.`;
                    handleFocus(field);
                }
            }
        }

        return errors ? errors : {};
    };

    const handleSaveTemp = async () => {
        try {
            const { data } = await getCommonInfo();
            if (data.memberBlocked === 'Y') {
                alert('등록 불가능한 회원입니다.');
                return;
            }

            if (payload.recruitTime && payload.recruitTime.length > 200) {
                alert('근무시간은 최대 200자까지 입력 가능합니다.');
                handleFocus('recruitTime');
                return;
            }

            if (payload.conditionEtc && payload.conditionEtc.length > 200) {
                alert('복리후생은 최대 200자까지 입력 가능합니다.');
                handleFocus('conditionEtc');
                return;
            }

            if (payload.needPaperEtc && payload.needPaperEtc.length > 200) {
                alert('제출서류은 최대 200자까지 입력 가능합니다.');
                handleFocus('needPaperEtc');
                return;
            }

            const formData = new FormData();
            const { chargeTel1, chargeTel2, chargeTel3, chargeMobile1, chargeMobile2, chargeMobile3 } =
                chargePhoneParts;

            const formatPhone = (part1, part2, part3) => (part1 && part2 && part3 ? `${part1}-${part2}-${part3}` : '');

            let updatedPayload = mergeApplyMethods(payload);
            updatedPayload.chargeTel = formatPhone(chargeTel1, chargeTel2, chargeTel3);
            updatedPayload.chargeMobile = formatPhone(chargeMobile1, chargeMobile2, chargeMobile3);
            updatedPayload = mergeRecruitCareerYear(updatedPayload);
            updatedPayload.recruitFlow = mergeRecruitFlow(updatedPayload);
            // updatedPayload.contents = $(editorRef.current).summernote('code');

            let html = $(editorRef.current).summernote('code');
            html = await uploadAndReplaceAllImages(html);
            updatedPayload.contents = html;



            delete updatedPayload.applyMethod002;
            delete updatedPayload.applyMethod003;
            delete updatedPayload.applyMethod004;
            delete updatedPayload.applyMethod005;
            delete updatedPayload.phoneNumber;
            delete updatedPayload.email;
            delete updatedPayload.fax;
            delete updatedPayload.address;
            delete updatedPayload.recruitCareerYearFrom;
            delete updatedPayload.recruitCareerYearTo;
            delete updatedPayload.recruitFlowCheck1;
            delete updatedPayload.recruitFlowCheck2;
            delete updatedPayload.recruitFlowCheck3;
            delete updatedPayload.recruitFlowText1;
            delete updatedPayload.recruitFlowText2;
            delete updatedPayload.recruitFlowText3;
            delete updatedPayload.recruitFlowTextOpen1;
            delete updatedPayload.recruitFlowTextOpen2;
            delete updatedPayload.recruitFlowTextOpen3;

            if (id && !isFlag) {
                updatedPayload.seq = id;
                formData.append('data', new Blob([JSON.stringify(updatedPayload)], { type: 'application/json' }));
                try {
                    await putPAJAC020Step1(formData);
                    alert('임시저장이 완료되었습니다.');
                } catch (error) {
                    console.error(error);
                }
            } else {
                delete updatedPayload.memberID;
                formData.append('data', new Blob([JSON.stringify(updatedPayload)], { type: 'application/json' }));
                try {
                    const { data } = await postPAJAC020Step1(formData);
                    alert('임시저장이 완료되었습니다.');
                    navigate(`/pajac020-${data.seq}?step=1`);
                } catch (error) {
                    console.error(error);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async () => {
        try {
            const errors = validateForm(payload);
            if (Object.keys(errors).length > 0) {
                let logMessage = '';
                for (const field in errors) {
                    logMessage += `${errors[field]}\n`;
                }
                logMessage = logMessage.slice(0, -1);
                window.alert(logMessage);
                return;
            }

            // const { data } = await getCommonInfo();
            // if (data.memberBlocked === 'Y') {
            //     alert('등록 불가능한 회원입니다.');
            //     return;
            // }
            if (payload.recruitTime && payload.recruitTime.length > 200) {
                alert('근무시간은 최대 200자까지 입력 가능합니다.');
                handleFocus('recruitTime');
                return;
            }

            if (payload.conditionEtc && payload.conditionEtc.length > 200) {
                alert('복리후생은 최대 200자까지 입력 가능합니다.');
                handleFocus('conditionEtc');
                return;
            }

            if (payload.needPaperEtc && payload.needPaperEtc.length > 200) {
                alert('제출서류은 최대 200자까지 입력 가능합니다.');
                handleFocus('needPaperEtc');
                return;
            }


            if (
                !payload.applyMethod1 &&
                !payload.applyMethod002 &&
                !payload.applyMethod003 &&
                !payload.applyMethod004 &&
                !payload.applyMethod005
            ) {
                window.alert('접수방법을 선택해 주세요.');
                handleFocus('phoneNumber');
                return;
            }
            if (
                ((!payload.phoneNumber || payload.phoneNumber === '') &&
                    !/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}$/.test(payload.phoneNumber.replace(/-/g, '')) &&
                    !payload.applyMethod1 &&
                    payload.applyMethod002) ||
                ((!payload.phoneNumber || payload.phoneNumber === '') &&
                    !/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}$/.test(payload.phoneNumber.replace(/-/g, '')) &&
                    payload.applyMethod002) ||
                (!/^[0-9]{2,3}[0-9]{3,4}[0-9]{4}$/.test(payload.phoneNumber.replace(/-/g, '')) &&
                    payload.applyMethod002)
            ) {
                window.alert('접수받을 전화번호를 기입해 주세요.');
                handleFocus('phoneNumber');
                return;
            }

            if (
                ((!payload.email || payload.email === '') &&
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(payload.email) &&
                    !payload.applyMethod1 &&
                    payload.applyMethod003) ||
                ((!payload.email || payload.email === '') &&
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(payload.email) &&
                    payload.applyMethod003) ||
                (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(payload.email) && payload.applyMethod003)
            ) {
                window.alert('접수받을 이메일 기입해 주세요.');
                handleFocus('email');
                return;
            }
            if (
                ((!payload?.fax || payload?.fax === '') && !payload.applyMethod1 && payload.applyMethod004) ||
                ((!payload?.fax || payload?.fax === '') && payload.applyMethod004)
            ) {
                alert('접수받을 FAX번호를 기입해 주세요.');
                handleFocus('fax');
                return;
            }
            if (
                ((!payload?.address || payload?.address === '') && !payload.applyMethod1 && payload.applyMethod005) ||
                ((!payload?.address || payload?.address === '') && payload.applyMethod005)
            ) {
                alert('접수받을 주소를 기입해 주세요.');
                handleFocus('address');
                return;
            }

            if (!payload?.charge || payload?.charge === '') {
                alert('담당자명을 입력해 주세요.');
                handleFocus('charge');
                return;
            }
            if (!payload?.chargeEmail || payload?.chargeEmail === '') {
                alert('담당자 이메일을 입력해 주세요.');
                handleFocus('chargeEmail');
                return;
            }

            if (!chargePhoneParts?.chargeTel1 || chargePhoneParts?.chargeTel1 === '') {
                alert('전화번호를 입력해 주세요.');
                handleFocus('chargeTel1');
                return;
            }
            if (!chargePhoneParts?.chargeTel2 || chargePhoneParts?.chargeTel2 === '') {
                alert('전화번호를 입력해 주세요.');
                handleFocus('chargeTel2');
                return;
            }
            if (!chargePhoneParts?.chargeTel3 || chargePhoneParts?.chargeTel3 === '') {
                alert('전화번호를 입력해 주세요.');
                handleFocus('chargeTel3');
                return;
            }
            if (!chargePhoneParts?.chargeMobile1 || chargePhoneParts?.chargeMobile1 === '') {
                alert('휴대폰번호를 입력해 주세요.');
                handleFocus('chargeMobile1');
                return;
            }
            if (!chargePhoneParts?.chargeMobile2 || chargePhoneParts?.chargeMobile2 === '') {
                alert('휴대폰번호를 입력해 주세요.');
                handleFocus('chargeMobile2');
                return;
            }
            if (!chargePhoneParts?.chargeMobile3 || chargePhoneParts?.chargeMobile3 === '') {
                alert('휴대폰번호를 입력해 주세요.');
                handleFocus('chargeMobile3');
                return;
            }

            if (!payload?.proposeSMS || payload?.proposeSMS === '') {
                alert('덴탈잡 쪽지 SMS 알림을 선택해 주세요.');
                handleFocus('proposeSMS');
                return;
            }

            const formData = new FormData();
            let updatedPayload = mergeApplyMethods(payload);
            updatedPayload = mergeRecruitCareerYear(updatedPayload);
            updatedPayload.recruitFlow = mergeRecruitFlow(updatedPayload);
            // updatedPayload.contents = $(editorRef.current).summernote('code');

            let html = $(editorRef.current).summernote('code');
            html = await uploadAndReplaceAllImages(html);
            updatedPayload.contents = html;

            if (mapSvr === 'N') {
                updatedPayload.mapStr = null;
                updatedPayload.pointX = null;
                updatedPayload.pointY = null;
            }

            const { chargeTel1, chargeTel2, chargeTel3, chargeMobile1, chargeMobile2, chargeMobile3 } =
                chargePhoneParts;

            const formatPhone = (part1, part2, part3) => (part1 && part2 && part3 ? `${part1}-${part2}-${part3}` : '');

            updatedPayload.chargeTel = formatPhone(chargeTel1, chargeTel2, chargeTel3);
            updatedPayload.chargeMobile = formatPhone(chargeMobile1, chargeMobile2, chargeMobile3);

            delete updatedPayload.applyMethod002;
            delete updatedPayload.applyMethod003;
            delete updatedPayload.applyMethod004;
            delete updatedPayload.applyMethod005;
            delete updatedPayload.phoneNumber;
            delete updatedPayload.email;
            delete updatedPayload.fax;
            delete updatedPayload.address;
            delete updatedPayload.recruitCareerYearFrom;
            delete updatedPayload.recruitCareerYearTo;
            delete updatedPayload.recruitFlowCheck1;
            delete updatedPayload.recruitFlowCheck2;
            delete updatedPayload.recruitFlowCheck3;
            delete updatedPayload.recruitFlowText1;
            delete updatedPayload.recruitFlowText2;
            delete updatedPayload.recruitFlowText3;
            delete updatedPayload.recruitFlowTextOpen1;
            delete updatedPayload.recruitFlowTextOpen2;
            delete updatedPayload.recruitFlowTextOpen3;
            delete updatedPayload.chargeTel1;
            delete updatedPayload.chargeTel2;
            delete updatedPayload.chargeTel3;
            delete updatedPayload.chargeMobile1;
            delete updatedPayload.chargeMobile2;
            delete updatedPayload.chargeMobile3;

            const confirm = isUpdate
                ? window.confirm('저장하시겠습니까?')
                : window.confirm('채용공고 저장 후 상품 선택 및 결제수단 선택 페이지로 이동하시겠습니까?');

            if (confirm) {
                if (id && !isFlag) {
                    updatedPayload.seq = id;
                    formData.append('data', new Blob([JSON.stringify(updatedPayload)], { type: 'application/json' }));
                    try {
                        const { data } = await putPAJAC020Step1(formData);
                        if (isUpdate) {
                            alert('저장되었습니다.');
                            navigate('/pajac010');
                        } else {
                            updateUserData({ seq: data.seq });
                        }
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    delete updatedPayload.memberID;
                    formData.append('data', new Blob([JSON.stringify(updatedPayload)], { type: 'application/json' }));
                    try {
                        const { data } = await postPAJAC020Step1(formData);
                        updateUserData({ seq: data.seq });
                    } catch (error) {
                        console.error(error);
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleCancel = () => {
        const confirm = window.confirm('저장하지 않고 페이지를 나가시겠습니까?');
        if (confirm) {
            navigate('/pajac010');
        }
    };
    useEffect(() => {
        mergeRecruitFlow(payload);
    }, [payload]);

    const handlePreview = () => {
        dispatch(
            updateData({
                ...payload,
                contents: $(editorRef.current).summernote('code'),
                A11,
                A10,
                A12,
                A14,
                A19,
                A26,
                A27,
                A31,
                A46,
                subwayNum1: payload.subwayNum1
                    ? getOptions('A16', 1).find((opt) => opt.value === payload.subwayNum1)?.option
                    : '',
                subwayNum2: payload.subwayNum2
                    ? getOptions('A16', 2).find((opt) => opt.value === payload.subwayNum2)?.option
                    : '',
                subwayNum3: payload.subwayNum3
                    ? getOptions('A16', 3).find((opt) => opt.value === payload.subwayNum3)?.option
                    : '',
                subwayPost1: payload.subwayPost1
                    ? getOptions('A17', 1).find((opt) => opt.value === payload.subwayPost1)?.option
                    : '',
                subwayPost2: payload.subwayPost2
                    ? getOptions('A17', 2).find((opt) => opt.value === payload.subwayPost2)?.option
                    : '',
                subwayPost3: payload.subwayPost3
                    ? getOptions('A17', 3).find((opt) => opt.value === payload.subwayPost3)?.option
                    : '',
                regionSi: payload.regionSi
                    ? regionSi.find((item) => String(item.code) === String(payload.regionSi))?.codeName ||
                      payload.regionSi
                    : '',
                regionGu: payload.regionGu
                    ? regionGu.find(
                          (item) =>
                              String(item.code) === String(payload.regionGu) &&
                              String(item.desct) === String(payload.regionSi),
                      )?.codeName || payload.regionGu
                    : '',
            }),
        );
    };

    useEffect(() => {
        dispatch(resetData());
    });

    return (
        <>
            <div className="rgst__top" style={isUpdate ? { marginTop: '15px' } : { marginTop: '0px' }}>
                <ImageCheckFallback
                    folderName={'recruit_logo'}
                    imgName={info?.avatar}
                    alt="logo"
                    classImg={'rgst__logo'}
                />
                <dl className="rgst__dl">
                    <dt className="rgst__dt">{info.bizCompany}</dt>
                    <dd className="rgst__dd">
                        {info.addressRoad} {info.addressDetail} / {info.nameKor}
                    </dd>
                </dl>
                <button type="button" className="rsm-mng__btn" onClick={() => navigate('/pajab020')}>
                    치과정보 관리
                </button>
            </div>
            <input
                type="text"
                className="rgst__tit-input"
                placeholder="채용공고 제목을 입력하세요."
                name="title"
                onChange={handleInputChange}
                value={payload.title || ''}
                maxLength={50}
            />
            <div className="resume__tit">
                <span style={{ color: '#0068b7', fontSize: '15px' }}>* 채용공고 제목에는 [ ] ( ) - & , . 의 특수문자만 사용가능합니다.</span>
            </div>


            <h4 className="rgst__sbj">근무위치</h4>
            <table className="rgst__table">
                <tbody>
                    <tr>
                        <th>
                            근무지<span>*</span>
                        </th>
                        <td>
                            <ul className="rgst-sbwy">
                                <li
                                    className="rgst-sbwy__item itemchild"
                                    style={{ display: 'flex' }}
                                >
                                    <div className="rgst__select">
                                        <Dropdown
                                            placeholder="시/도 선택"
                                            options={getOptions('RegionSi')}
                                            name="regionSi"
                                            id="regionSi"
                                            value={payload.regionSi || ''}
                                            onChange={(valueOption) => {
                                                handleInputChange({
                                                    target: {
                                                        name: 'regionSi',
                                                        value: valueOption,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="rgst__select">
                                        <Dropdown
                                            placeholder="군/구"
                                            options={getOptions('RegionGu')}
                                            name="regionGu"
                                            id="regionGu"
                                            value={payload.regionGu || ''}
                                            onChange={(valueOption) => {
                                                handleInputChange({
                                                    target: {
                                                        name: 'regionGu',
                                                        value: valueOption,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>

                                    <input
                                        type="text"
                                        className="rgst__input"
                                        name="regionDetail"
                                        placeholder="상세주소"
                                        maxLength={100}
                                        onChange={handleInputChange}
                                        value={payload.regionDetail || ''}
                                    ></input>
                                    <p>{(payload.regionDetail?.length || 0)}/100</p>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>인근지하철역</th>
                        <td>
                            <ul className="rgst-sbwy">
                                <li className="rgst-sbwy__item">
                                    1.
                                    <div className="rgst__select">
                                        <Dropdown
                                            placeholder=""
                                            options={[{ id: 'a16_empty_1', option: '호선선택', value: '' }, ...getOptions('A16', 1)]}
                                            allowEmpty
                                            value={payload.subwayNum1 || ''}
                                            name="subwayNum1"
                                            onChange={(valueOption) => {
                                                handleInputChange({
                                                    target: {
                                                        name: 'subwayNum1',
                                                        value: valueOption,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="rgst__select">
                                        <Dropdown
                                            placeholder=""
                                            options={[{ id: 'a17_empty_1', option: '역명선택', value: '' }, ...getOptions('A17', 1)]}
                                            allowEmpty
                                            checkCondition={checkSubwayPosts?.subwayPost1}
                                            setCheckSubwayPosts={setCheckSubwayPosts}
                                            name="subwayPost1"
                                            value={payload.subwayPost1 || ''}
                                            onChange={(valueOption) => {
                                                handleInputChange({
                                                    target: {
                                                        name: 'subwayPost1',
                                                        value: valueOption,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="rgst__desc pl10">
                                        *인근 지하철역은 최대 3군데까지 입력하실 수 있습니다.
                                    </div>
                                </li>
                                <li className="rgst-sbwy__item">
                                    2.
                                    <div className="rgst__select">
                                        <Dropdown
                                            placeholder=""
                                            options={[{ id: 'a16_empty_2', option: '호선선택', value: '' }, ...getOptions('A16', 2)]}
                                            allowEmpty
                                            name="subwayNum2"
                                            value={payload.subwayNum2 || ''}
                                            onChange={(valueOption) => {
                                                handleInputChange({
                                                    target: {
                                                        name: 'subwayNum2',
                                                        value: valueOption,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="rgst__select">
                                        <Dropdown
                                            placeholder=""
                                            options={[{ id: 'a17_empty_2', option: '역명선택', value: '' }, ...getOptions('A17', 2)]}
                                            allowEmpty
                                            checkCondition={checkSubwayPosts?.subwayPost2}
                                            setCheckSubwayPosts={setCheckSubwayPosts}
                                            name="subwayPost2"
                                            value={payload.subwayPost2 || ''}
                                            onChange={(valueOption) => {
                                                handleInputChange({
                                                    target: {
                                                        name: 'subwayPost2',
                                                        value: valueOption,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                </li>
                                <li className="rgst-sbwy__item">
                                    3.
                                    <div className="rgst__select">
                                        <Dropdown
                                            placeholder=""
                                            options={[{ id: 'a16_empty_3', option: '호선선택', value: '' }, ...getOptions('A16', 3)]}
                                            allowEmpty
                                            name="subwayNum3"
                                            value={payload.subwayNum3 || ''}
                                            onChange={(valueOption) => {
                                                handleInputChange({
                                                    target: {
                                                        name: 'subwayNum3',
                                                        value: valueOption,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="rgst__select">
                                        <Dropdown
                                            placeholder=""
                                            options={[{ id: 'a17_empty_3', option: '역명선택', value: '' }, ...getOptions('A17', 3)]}
                                            allowEmpty
                                            checkCondition={checkSubwayPosts?.subwayPost3}
                                            setCheckSubwayPosts={setCheckSubwayPosts}
                                            name="subwayPost3"
                                            value={payload.subwayPost3 || ''}
                                            onChange={(valueOption) => {
                                                handleInputChange({
                                                    target: {
                                                        name: 'subwayPost3',
                                                        value: valueOption,
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>위치설명</th>
                        <td>
                            <input
                                type="text"
                                className="rgst__input"
                                name="bizAddrDesc"
                                value={payload.bizAddrDesc || ''}
                                onChange={handleInputChange}
                            />
                            <div className="rgst__desc mt10">*예) 홈플러스 맞은편 국민은행 5층</div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            상세지도 서비스 이용
                            <br />
                            <div className="rgst__select">
                                <div className="form-select-container">
                                    <Dropdown
                                        placeholder=""
                                        options={[
                                            { id: 'mapSvr_Y', option: '이용함', value: 'Y' },
                                            {
                                                id: 'mapSvr_N',
                                                option: '이용 안 함',
                                                value: 'N',
                                            },
                                        ]}
                                        value={payload.mapSvr}
                                        name="mapSvr"
                                        onChange={(valueOption) => {
                                            setMapSvr(valueOption);
                                            handleInputChange({
                                                target: {
                                                    name: 'mapSvr',
                                                    value: valueOption,
                                                },
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </th>
                        <td>
                            <div className="rgst-map">
                                <button
                                    type="button"
                                    className="rgst-map__btn"
                                    onClick={() => handleOpenPopupMap('edit')}
                                >
                                    <i />
                                    위치정보등록
                                </button>
                                <div className="rgst-map__info">
                                    <div className="rgst-map__tit">등록된 위치 정보</div>
                                    <div className="rgst-map__block">
                                        <div className="rgst-map__adr">
                                            <span>- 주소 :</span> <span>{mapSvr === 'Y' && payload.mapStr}</span>
                                        </div>
                                        <div className="rgst__desc font-light mt10">
                                            • 상세지도서비스의 등록방법이 변경되었습니다. 상세지도서비스 설정창에서
                                            위치를 선택한 후 위치정보를 저장해 주세요.
                                        </div>
                                        <div className="rgst__desc font-bold mt10">
                                            • 정확한 지도정보가 등록되지 않은 경우 덴틸잡 앱 및 구글지도 등에서 다르게
                                            보일 수 있습니다.
                                        </div>
                                        <button type="button" className="rgst-map__btn2" onClick={handleOpenPopupMap}>
                                            지도미리보기
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            {showPopupMap && isEditMode && (
                <PinAddress setPosition={setPosition} setPayload={setPayload} setShowPopupMap={setShowPopupMap} />
            )}
            {showPopupMap && !isEditMode && <PreviewPinAddress position={position} setShowPopupMap={setShowPopupMap} />}

            <h4 className="rgst__sbj">채용 정보</h4>
            <table className="rgst__table">
                <tbody>
                    <tr>
                        <th>
                            담당업무<span>*</span>
                        </th>
                        <td id="recruitClass">
                            <div className="rgst__grid">
                                <Checkbox
                                    name="recruitClass"
                                    options={getOptions('A11')}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitCodes(payload.recruitClass)}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            자격증 소지<span>*</span>
                        </th>
                        <td id="recruitLicense">
                            <div className="rgst__grid">
                                <Checkbox
                                    name="recruitLicense"
                                    options={getOptions('A14')}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitCodes(payload.recruitLicense)}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            근무형태<span>*</span>
                        </th>
                        <td id="recruitForm">
                            <div className="rgst__grid">
                                <Checkbox
                                    name="recruitForm"
                                    options={getOptions('A12')}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitCodes(payload.recruitForm)}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            모집인원<span>*</span>
                        </th>
                        <td>
                            <div className="rgst__num">
                                <input
                                    type="text"
                                    className="rgst__input"
                                    name="recruitNum"
                                    onChange={handleInputChange}
                                    value={payload.recruitNum || ''}
                                />
                                명
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            직급<span>*</span>
                        </th>
                        <td id="recruitPosition">
                            <div className="rgst__grid">
                                <Checkbox
                                    name="recruitPosition"
                                    options={getOptions('A27')}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.recruitPosition)}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            급여<span>*</span>
                        </th>
                        <td id="recruitPayEtc">
                            <div className="rgst__pay">
                                <div className="rgst__select">
                                    <Dropdown
                                        placeholder="급여"
                                        options={getOptions('A26')}
                                        name="recruitPay"
                                        onChange={handleOptionChange}
                                        id="recruitPay"
                                        value={payload.recruitPay}
                                    />
                                </div>
                                {payload.recruitPay === '직접입력' && (
                                    <>
                                        <input
                                            type="text"
                                            className="rgst__input"
                                            name="recruitPayEtc"
                                            onChange={handleInputChange}
                                            maxLength={200}
                                            value={payload.recruitPayEtc || ''}
                                        />
                                        <div className="rgst__desc pl10">*급여항목이 직접입력인 경우 입력하세요. </div>
                                    </>
                                )}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            자격요건<span>*</span>
                        </th>
                        <td>
                            <div className="rgst__qlf">
                                <div className="rgst__qlf-lf">
                                    학력 :
                                    <div className="rgst__select wd160">
                                        <Dropdown
                                            placeholder="학력선택"
                                            options={[
                                                { id: 'recruitGrade_1', value: '001', option: '고등학교졸업' },
                                                { id: 'recruitGrade_2', value: '002', option: '전문대학1년재중' },
                                                { id: 'recruitGrade_3', value: '003', option: '전문대학2년재중' },
                                                { id: 'recruitGrade_4', value: '004', option: '전문대학3년재중' },
                                                { id: 'recruitGrade_5', value: '005', option: '전문대학졸업' },
                                                { id: 'recruitGrade_6', value: '006', option: '대학교1년재중' },
                                                { id: 'recruitGrade_7', value: '007', option: '대학교2년재중' },
                                                { id: 'recruitGrade_8', value: '008', option: '대학교3년재중' },
                                                { id: 'recruitGrade_9', value: '009', option: '대학교4년재중' },
                                                { id: 'recruitGrade_10', value: '010', option: '대학교졸업(학사)' },
                                                { id: 'recruitGrade_11', value: '011', option: '대학원재중' },
                                                { id: 'recruitGrade_12', value: '012', option: '대학원졸업(석사)' },
                                                { id: 'recruitGrade_13', value: '013', option: '대학원졸업(박사)' },
                                            ]}
                                            name="recruitGrade"
                                            onChange={handleOptionChange}
                                            id="recruitGrade"
                                            value={payload.recruitGrade}
                                        />
                                    </div>
                                    이상
                                </div>
                                <div className="rgst__qlf-rt">
                                    (기타 학력조건{'  '}
                                    <input
                                        type="text"
                                        className="rgst__input"
                                        placeholder="(200자 이내)"
                                        name="recruitGradeEtc"
                                        maxLength={200}
                                        onChange={handleInputChange}
                                        value={payload.recruitGradeEtc || ''}
                                    />
                                    <p>{(payload.recruitGradeEtc?.length || 0)}/200</p>
                                    )
                                </div>
                            </div>
                            <div className="rgst__qlf gap25">
                                <div className="rgst__qlf-lf">
                                    경력 :
                                    <div className="rgst__select wd160">
                                        <Dropdown
                                            placeholder="경력선택"
                                            options={[
                                                { id: 'recruitCareer_1', option: '신입', value: '신입' },
                                                { id: 'recruitCareer_2', option: '경력', value: '경력' },
                                                { id: 'recruitCareer_3', option: '무관', value: '무관' },
                                            ]}
                                            name="recruitCareer"
                                            onChange={handleOptionChange}
                                            id="recruitCareer"
                                            value={payload.recruitCareer}
                                        />
                                    </div>
                                </div>
                                {payload.recruitCareer === '경력' && (
                                    <>
                                        {' '}
                                        <div className="rgst__qlf-rt">
                                            (경력년수{'  '}
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                className="rgst__input wd70"
                                                name="recruitCareerYearFrom"
                                                onChange={handleInputChange}
                                                value={payload.recruitCareerYearFrom || ''}
                                            />
                                            년 ~
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                className="rgst__input wd70"
                                                name="recruitCareerYearTo"
                                                onChange={handleInputChange}
                                                value={payload.recruitCareerYearTo || ''}
                                            />
                                            년)
                                        </div>
                                        <div style={{ marginLeft: '-10px' }} className="rgst__desc">
                                            (*경력항목이 경력인 경우 입력하세요.)
                                        </div>
                                    </>
                                )}
                            </div>
                        </td>
                    </tr>
                    <tr id='content-detail'>
                        <th>세부사항</th>
                        <td>
                            <div ref={editorRef} style={{ height: '300px' }} />
                            <div className="rgst__desc mt10">
                                *예) 관리자의 포부를 갖고 계신 분, 스켈링 가능하신 분 환영합니다.
                            </div>
                            {/* <div className="rgst__desc mt10 red">*특수문자(&amp;)기호는 사용하 실 수 없습니다.</div> */}
                        </td>
                    </tr>
                </tbody>
            </table>
            <h4 className="rgst__sbj">근무환경/복리후생</h4>
            <table className="rgst__table">
                <tbody>
                    <tr>
                        <th>
                            근무요일<span>*</span>
                        </th>
                        <td>
                            <div className="rgst__day">
                                <Radiobox
                                    name="recruitDay"
                                    options={getOptions('A19')}
                                    onChange={handleCheckboxChange}
                                    checked={payload}
                                />
                            </div>
                            <div className="rgst__day2">
                                <Radiobox
                                    name="recruitDay"
                                    options={getOptions('A19', '999')}
                                    onChange={handleCheckboxChange}
                                    checked={payload}
                                />
                                <input
                                    type="text"
                                    className="rgst__input"
                                    name="recruitDayEtc"
                                    onChange={handleInputChange}
                                    maxLength={150}
                                    value={
                                        payload.recruitDayEtc && payload.recruitDay === '999'
                                            ? payload.recruitDayEtc
                                            : ''
                                    }
                                    readOnly={payload.recruitDay !== '999'}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>근무시간</th>
                        <td>
                            <textarea
                                style={{ whiteSpace: 'pre-line' }}
                                type="text"
                                className="rgst__input rgst__textarea hi100"
                                placeholder={
                                    '예) 월~금 : 오전 9시 ~ 오후6시, 수요일 야간진료(오후 10시까지), 주말 격주 근무 선택 가능 등\n(200자 이내)'
                                }
                                name="recruitTime"
                                onChange={handleInputChange}
                                maxLength={200}
                                value={payload.recruitTime || ''}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>복리후생</th>
                        <td>
                            <div className="rgst__grid">
                                <Checkbox
                                    name="assist1"
                                    options={getOptions('A31', ['101', '102'])}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.assist1)}
                                />
                                <Checkbox
                                    name="assist2"
                                    options={getOptions('A31', ['201'])}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.assist2)}
                                />
                                <Checkbox
                                    name="assist3"
                                    options={getOptions('A31', ['301', '302', '303'])}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.assist3)}
                                />
                                <Checkbox
                                    name="assist4"
                                    options={getOptions('A31', ['401'])}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.assist4)}
                                />
                                <Checkbox
                                    name="assist5"
                                    options={getOptions('A31', ['501', '502', '503', '504', '505'])}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.assist5)}
                                />
                            </div>
                            <textarea
                                style={{ whiteSpace: 'pre-line' }}
                                type="text"
                                className="rgst__input rgst__textarea hi100"
                                placeholder="예) 연차 2회, 우수직원 포상, 세미나비 지원 등 (200자 이내)"
                                name="conditionEtc"
                                onChange={handleInputChange}
                                maxLength={200}
                                value={payload.conditionEtc || ''}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <h4 className="rgst__sbj">접수 방법</h4>
            <table className="rgst__table">
                <tbody>
                    <tr>
                        <th>
                            접수방법<span>*</span>
                        </th>
                        <td id="applyMethod">
                            <Checkbox
                                name="applyMethod1"
                                options={[
                                    {
                                        id: 'applyMethod1',
                                        value: '001',
                                        label: '덴탈잡 온라인시스템 접수',
                                        classText: 'rgst__label blue-bold',
                                    },
                                ]}
                                onChange={handleCheckboxChange}
                                checkedValues={splitList(payload.applyMethod1)}
                            />
                            <ul className="rgst__way">
                                <li>덴탈잡 [마이 페이지 덴탈잡 지원자 관리] 메뉴에서 내용을 확인할 수 있습니다.</li>
                                <li>
                                    구직자들이 가장 희망하는 접수 방법이며, 이력서 수신시 문자로 안내(선택사항) 받을 수
                                    있습니다.
                                </li>
                            </ul>
                            <div className="rgst__sbm">
                                <Checkbox
                                    name="applyMethod002"
                                    options={[{ id: 'applyMethod002', value: '002', label: '전화접수' }]}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.applyMethod002)}
                                />
                                <input
                                    type="text"
                                    className="rgst__input"
                                    placeholder="접수받을 전화번호를 기입해 주세요."
                                    name="phoneNumber"
                                    onChange={handleInputChange}
                                    disabled={payload.applyMethod002 !== '002'}
                                    maxLength={20}
                                    value={payload.phoneNumber || ''}
                                />
                            </div>
                            <div className="rgst__sbm">
                                <Checkbox
                                    name="applyMethod003"
                                    options={[{ id: 'applyMethod003', value: '003', label: '이메일' }]}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.applyMethod003)}
                                />
                                <input
                                    type="text"
                                    className="rgst__input"
                                    placeholder="접수받을 이메일 기입해 주세요."
                                    name="email"
                                    onChange={handleInputChange}
                                    disabled={payload.applyMethod003 !== '003'}
                                    value={payload.email || ''}
                                    maxLength={100}
                                />
                            </div>
                            <div className="rgst__sbm">
                                <Checkbox
                                    name="applyMethod004"
                                    options={[{ id: 'applyMethod004', value: '004', label: 'FAX접수' }]}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.applyMethod004)}
                                />
                                <input
                                    type="text"
                                    className="rgst__input"
                                    placeholder="접수받을 FAX번호를 기입해 주세요."
                                    name="fax"
                                    onChange={handleInputChange}
                                    disabled={payload.applyMethod004 !== '004'}
                                    value={payload.fax || ''}
                                />
                            </div>
                            <div className="rgst__sbm">
                                <Checkbox
                                    name="applyMethod005"
                                    options={[{ id: 'applyMethod005', value: '005', label: '우편접수' }]}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.applyMethod005)}
                                />
                                <input
                                    type="text"
                                    className="rgst__input"
                                    placeholder="접수받을 주소를 기입해 주세요."
                                    name="address"
                                    onChange={handleInputChange}
                                    disabled={payload.applyMethod005 !== '005'}
                                    value={payload.address || ''}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>제출서류</th>
                        <td>
                            <div className="rgst__paper">
                                <Checkbox
                                    name="needPaper"
                                    options={getOptions('A46')}
                                    onChange={handleCheckboxChange}
                                    checkedValues={splitList(payload.needPaper)}
                                />
                            </div>
                            <textarea
                                className="rgst__textarea hi100"
                                placeholder="(200자 이내)"
                                name="needPaperEtc"
                                maxLength={200}
                                onChange={handleInputChange}
                                value={payload.needPaperEtc || ''}
                            />
                            <p>{(payload.needPaperEtc?.length || 0)}/200</p>
                        </td>
                    </tr>
                    <tr>
                        <th>전형방법</th>
                        <td>
                            <div className="rgst__type">
                                <label className="rgst__label blk">
                                    <input
                                        type="checkbox"
                                        className="rgst__checkbox blk"
                                        name="recruitFlowCheck1"
                                        onChange={handleCheckbox}
                                        checked={payload.recruitFlowCheck1 === '1차'}
                                        value="1차"
                                    />
                                    1차
                                </label>
                                <div className="rgst__select has-input">
                                    <Dropdown
                                        placeholder="전형방법 선택"
                                        name="recruitFlowText1"
                                        options={[
                                            { id: 'recruitFlowText1_1', option: '서류전형', value: '서류전형' },
                                            { id: 'recruitFlowText1_2', option: '면접', value: '면접' },
                                            { id: 'recruitFlowText1_3', option: '최종면접', value: '최종면접' },
                                            { id: 'recruitFlowText1_4', option: '직접 입력', value: '직접 입력' },
                                        ]}
                                        onChange={handleOptionChange}
                                        disabled={payload.recruitFlowCheck1 !== '1차'}
                                        value={payload.recruitFlowText1}
                                    />
                                    {payload.recruitFlowText1 === '직접 입력' &&
                                        payload.recruitFlowCheck1 === '1차' && (
                                            <input
                                                type="text"
                                                className="rgst__input max-330"
                                                name="recruitFlowTextOpen1"
                                                onChange={handleInputChange}
                                                value={payload.recruitFlowTextOpen1 || ''}
                                            />
                                        )}
                                </div>
                            </div>
                            <div className="rgst__type">
                                <label className="rgst__label blk">
                                    <input
                                        type="checkbox"
                                        className="rgst__checkbox blk"
                                        name="recruitFlowCheck2"
                                        onChange={handleCheckbox}
                                        checked={
                                            payload.recruitFlowCheck1 === '1차' && payload.recruitFlowCheck2 === '2차'
                                        }
                                        value="2차"
                                        disabled={payload.recruitFlowCheck1 !== '1차'}
                                    />
                                    2차
                                </label>
                                <div className="rgst__select has-input">
                                    <Dropdown
                                        placeholder="전형방법 선택"
                                        name="recruitFlowText2"
                                        options={[
                                            { id: 'recruitFlowText2_1', option: '서류전형', value: '서류전형' },
                                            { id: 'recruitFlowText2_2', option: '면접', value: '면접' },
                                            { id: 'recruitFlowText2_3', option: '최종면접', value: '최종면접' },
                                            { id: 'recruitFlowText2_4', option: '직접 입력', value: '직접 입력' },
                                        ]}
                                        onChange={handleOptionChange}
                                        disabled={payload.recruitFlowCheck2 !== '2차'}
                                        value={payload.recruitFlowText2}
                                    />
                                    {payload.recruitFlowText2 === '직접 입력' &&
                                        payload.recruitFlowCheck2.includes('2차') && (
                                            <input
                                                type="text"
                                                className="rgst__input max-330"
                                                name="recruitFlowTextOpen2"
                                                onChange={handleInputChange}
                                                value={payload.recruitFlowTextOpen2 || ''}
                                            />
                                        )}
                                </div>
                            </div>
                            <div className="rgst__type">
                                <label className="rgst__label blk">
                                    <input
                                        type="checkbox"
                                        className="rgst__checkbox blk"
                                        name="recruitFlowCheck3"
                                        onChange={handleCheckbox}
                                        checked={
                                            payload.recruitFlowCheck2 === '2차' && payload.recruitFlowCheck3 === '3차'
                                        }
                                        value="3차"
                                        disabled={payload.recruitFlowCheck2 !== '2차'}
                                    />
                                    3차
                                </label>
                                <div className="rgst__select has-input">
                                    <Dropdown
                                        placeholder="전형방법 선택"
                                        name="recruitFlowText3"
                                        options={[
                                            { id: 'recruitFlowText3_1', option: '서류전형', value: '서류전형' },
                                            { id: 'recruitFlowText3_2', option: '면접', value: '면접' },
                                            { id: 'recruitFlowText3_3', option: '최종면접', value: '최종면접' },
                                            { id: 'recruitFlowText3_4', option: '직접 입력', value: '직접 입력' },
                                        ]}
                                        disabled={payload.recruitFlowCheck3 !== '3차'}
                                        onChange={handleOptionChange}
                                        value={payload.recruitFlowText3}
                                    />
                                    {payload.recruitFlowText3 === '직접 입력' &&
                                        payload.recruitFlowCheck3 === '3차' && (
                                            <>
                                                <input
                                                    type="text"
                                                    className="rgst__input max-330"
                                                    name="recruitFlowTextOpen3"
                                                    maxLength={200}
                                                    onChange={handleInputChange}
                                                    value={payload.recruitFlowTextOpen3 || ''}
                                                />
                                                <p style={{ marginTop: '10px' }}>{(payload.recruitFlowTextOpen3?.length || 0)}/200</p>
                                            </>
                                        )}

                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <h4 className="rgst__sbj">채용 담당자 정보</h4>
            {/* <table className="rsm-dtl__table rsm-dtl__table--ver2 wd160 modify">
                <tbody>
                   
                </tbody>
            </table> */}
            <table className="rgst__table">
                <tbody>
                    <tr>
                        <th>
                            담당자명<span className="required">*</span>
                        </th>
                        <td>
                            <input
                                type="text"
                                className="dntInf__input"
                                value={payload.charge || ''}
                                name="charge"
                                onChange={handleInputChange}
                                maxLength={50}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            담당자 이메일<span className="required">*</span>
                        </th>
                        <td>
                            <input
                                type="text"
                                className="dntInf__input"
                                value={payload.chargeEmail || ''}
                                name="chargeEmail"
                                onChange={handleInputChange}
                                maxLength={100}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            전화번호<span className="required">*</span>
                        </th>
                        <td
                            style={{
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center',
                                height: '58.5px',
                            }}
                        >
                            <Dropdown
                                placeholder="02"
                                options={PHONE_OPTIONS}
                                name="chargeTel1"
                                id="chargeTel1"
                                value={chargePhoneParts.chargeTel1 || ''}
                                onChange={(valueOption) => handlePhonePartChange('chargeTel1', valueOption)}
                                className="dntInf__dropdown"
                            />
                            -
                            <input
                                style={{ maxWidth: '98px', textAlign: 'center' }}
                                type="tel"
                                className="dntInf__input"
                                name="chargeTel2"
                                id="chargeTel2"
                                value={chargePhoneParts.chargeTel2 || ''}
                                onChange={(e) => handlePhonePartChange('chargeTel2', e.target.value)}
                                maxLength={4}
                            />
                            -
                            <input
                                style={{ maxWidth: '98px', textAlign: 'center' }}
                                type="tel"
                                className="dntInf__input"
                                name="chargeTel3"
                                id="chargeTel3"
                                value={chargePhoneParts.chargeTel3 || ''}
                                onChange={(e) => handlePhonePartChange('chargeTel3', e.target.value)}
                                maxLength={4}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            휴대폰<span className="required">*</span>
                        </th>
                        <td
                            style={{
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center',
                                height: '58px',
                            }}
                        >
                            <Dropdown
                                placeholder="010"
                                options={[
                                    { value: '010', option: '010' },
                                    { value: '011', option: '011' },
                                    { value: '016', option: '016' },
                                    { value: '017', option: '017' },
                                    { value: '018', option: '018' },
                                    { value: '019', option: '019' },
                                ]}
                                name="chargeMobile1"
                                id="chargeMobile1"
                                value={chargePhoneParts.chargeMobile1 || ''}
                                onChange={(valueOption) => handlePhonePartChange('chargeMobile1', valueOption)}
                                className="dntInf__dropdown"
                            />
                            -
                            <input
                                style={{ maxWidth: '98px', textAlign: 'center' }}
                                type="tel"
                                className="dntInf__input"
                                value={chargePhoneParts.chargeMobile2 || ''}
                                name="chargeMobile2"
                                onChange={(e) => handlePhonePartChange('chargeMobile2', e.target.value)}
                                maxLength={4}
                            />
                            -
                            <input
                                style={{ maxWidth: '98px', textAlign: 'center' }}
                                type="tel"
                                className="dntInf__input"
                                value={chargePhoneParts.chargeMobile3 || ''}
                                name="chargeMobile3"
                                onChange={(e) => handlePhonePartChange('chargeMobile3', e.target.value)}
                                maxLength={4}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            덴탈잡 쪽지 SMS
                            <br />
                            알림<span>*</span>
                        </th>
                        <td>
                            <div className="rgst__sms mgl-20">
                                <label className="rgst__label2">
                                    <input
                                        type="radio"
                                        name="proposeSMS"
                                        value="Y"
                                        onChange={handleCheckboxChange}
                                        checked={payload.proposeSMS === 'Y'}
                                    />
                                    수신허용
                                </label>
                                <label className="rgst__label2">
                                    <input
                                        type="radio"
                                        name="proposeSMS"
                                        value="N"
                                        onChange={handleCheckboxChange}
                                        checked={payload.proposeSMS === 'N'}
                                    />
                                    수신불가
                                </label>
                            </div>
                            <div className="rgst__desc mt10">
                                *'수신허용'을 선택하시면 이력서 및 덴탈잡 쪽지 수신시 채용담당자의 핸드폰으로 문자
                                알림을 받을 수 있습니다.
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div
                className="resume__snpts style-resume__snpts"
                style={isUpdate ? { marginTop: '20px' } : { borderTop: 0 }}
            >
                <span>{payload?.title}</span>
                <div className="resume__btbx2">
                    <div className="resume__btbx3">
                        {!isUpdate && (
                            <>
                                <button
                                    type="button"
                                    className="resume__btn2 resume__btn2--blk"
                                    onClick={(e) => {
                                        handlePreview();
                                        const newWindow = window.open(
                                            `/pajac051-preview`,
                                            '_blank',
                                            'width=1200,height=1000',
                                        );
                                        if (!newWindow) {
                                            e.preventDefault();
                                        }
                                    }}
                                >
                                    미리보기
                                </button>
                            </>
                        )}
                        <button className="resume__btn2 resume__btn2--blk" onClick={handleCancel}>
                            취소
                        </button>
                        {!isUpdate && (
                            <>
                                <button
                                    type="button"
                                    className="resume__btn2 resume__btn2--blk"
                                    onClick={handleSaveTemp}
                                >
                                    임시저장
                                </button>
                            </>
                        )}
                    </div>
                    <button onClick={handleSubmit} type="button" className="resume__btn2">
                        {!isUpdate ? '저장완료 및 채용광고 상품 선택' : '수정 완료'}
                    </button>
                </div>
            </div>
        </>
    );
};
export default PAJAC020;
